import Cookies from 'js-cookie';
import { logger } from '@/utils/logger';
import { useEffect, useState } from 'react';
import { StructuredText } from 'react-datocms';
import type { Document } from 'datocms-structured-text-utils';
import { customNodeRules } from '@/components/structuredText';
import { useInformationBannerQuery } from '@/utils/dato/generated';

const COOKIE_KEY = 'galleria-banner';

export const InformationBanner = () => {
  const [visible, setVisible] = useState(false);
  const { error, data } = useInformationBannerQuery();

  useEffect(() => {
    setVisible(!Cookies.get(COOKIE_KEY));
  }, []);

  if (data?.banner?.toggle && visible) {
    return (
      <div className="relative bg-warning py-3 pr-8 pl-6 [&>p]:mb-1">
        <StructuredText data={{ value: data.banner.body?.value as Document }} customNodeRules={customNodeRules} />
        <button
          onClick={() => {
            Cookies.set(COOKIE_KEY, 'true', { expires: 1 });
            setVisible(false);
          }}
          className="absolute top-2 right-2 p-2 bg-transparent border-0 cursor-pointer"
          type="button"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 text-primary" viewBox="0 0 352 512">
            <title>Close the banner</title>
            <path
              d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
              fill="currentColor"
            />
          </svg>
          <span className="sr-only">Close the banner</span>
        </button>
      </div>
    );
  }

  if (error) {
    logger.error({
      message: '[Information Banner] - Unable to get information needed to display the banner',
      error,
    });
  }

  return null;
};
